import { FunctionalComponent, Host, h } from '@stencil/core';
import state from '@ugc-store';
import { stringFormat } from '@ugc-utils/utils';
import { IViewMobile } from './interfaces';
const ViewDesktop: FunctionalComponent<IViewMobile> = ({
  isPadSize = false,
  onInput = () => {},
  onSortSelectList = () => {},
  onFilterSelectList = () => {},
}) => {
  const {
    qnaStaticLanguage: {
      IDS_LBL_SEARCH = '',
      IDS_UGC_CATEGORY = '',
      IDS_UGC_QNA_SEARCH_RESULT_COUNT = '',
      IDS_UGC_QNA_SORT_BY = '',
    },
    isFirstLoad,
    sortId,
    cid,
    categoryList,
    sorterList,
    textToSearch,
    qids,
    qnaListTotalCount,
  } = state;
  const filterCountText = stringFormat(IDS_UGC_QNA_SEARCH_RESULT_COUNT, qnaListTotalCount);
  const isShowList = qids.length > 0 || (!isFirstLoad && qids.length === 0);
  // style
  const inputStyle = { flex: '1' };
  const filterStyle = isPadSize ? { minWidth: '150px' } : { minWidth: '200px' };
  // render search input
  const renderSearchInput = (
    <ugc-input
      inputName={IDS_LBL_SEARCH}
      isShowSearchIcon={true}
      style={inputStyle}
      onInputChange={e => onInput(e)}
      data-testid="pdp-qna-search"
    />
  );
  // render filter input
  const renderFilterBy = (
    <ugc-select
      selectName={IDS_UGC_CATEGORY}
      selectNameTitle={IDS_UGC_CATEGORY}
      value={cid}
      data={categoryList}
      onSelectList={data => onFilterSelectList(data)}
      height="48px"
      style={{ ...filterStyle }}
      gaEventAction="qna filter"
      gaEventLabel="topic"
      gaEventName="ugc_qna"
      data-testid="pdp-qna-filter"
    />
  );
  // render sort by
  const renderSortBy = (
    <ugc-select
      style={filterStyle}
      selectName={IDS_UGC_QNA_SORT_BY}
      selectNameTitle={IDS_UGC_QNA_SORT_BY}
      value={sortId}
      data={sorterList}
      onSelectList={data => onSortSelectList(data)}
      height="48px"
      gaEventAction="qna filter"
      gaEventLabel="sort"
      gaEventName="ugc_qna"
      data-testid="pdp-qna-sort"
    />
  );
  // render filter count text
  const renderFilterCountText = !isFirstLoad && textToSearch !== '' && (
    <p class="mb-48 bold fs-18">{filterCountText}</p>
  );
  return (
    isShowList && (
      <Host>
        <div class="w-full flex flex-wrap mt-24 mb-24 gap-16">
          {renderSearchInput}
          {renderFilterBy}
          {renderSortBy}
          <div style={isPadSize ? { width: '138px' } : { width: '200px' }}>
            <ugc-qna-ask-question data-testid="pdp-qna-ask-question" />
          </div>
        </div>
        {renderFilterCountText}
      </Host>
    )
  );
};
export default ViewDesktop;
